/**
 * NGXS Storage Plugin state migrations.
 *
 * Each entry runs once when a user's persisted state matches the
 * specified `version`. After running, the version is bumped so the
 * migration is never applied again.
 *
 * For field-level safety on every load (missing fields, type mismatches, etc.)
 * see `state-sanitizer.ts` which provides the `afterDeserialize` hook.
 */

import { produce } from 'immer';
import type { MultiViewStateModel } from './multi-view/MultiViewStateModel';

export const STATE_MIGRATIONS = [
  {
    version: 0,
    migrate: (state: any) => ({
      ...state,
      version: 1,
    }),
  },
  {
    version: 1,
    key: 'settings_state',
    versionKey: 'settings_state_version',
    migrate: (state: any) => ({
      ...state,
      settings_page: {
        bu_settings: {
          labels: {
            available: [],
          },
        },
      },
      version: 2,
    }),
  },
  {
    version: 2,
    key: 'add_ui_styles_to_store',
    versionKey: 'ui_state_version',
    migrate: (state: any) => {
      const multi_view_state = state.multi_view_state as MultiViewStateModel;
      produce(multi_view_state.views, (viewDraft) => {
        viewDraft.forEach((_v, i) => {
          if (!viewDraft[i].styles) {
            viewDraft[i].styles = {
              datatree: { width: '15%' },
              sensortable: { height: '300px' },
            };
          }
        });
      });

      return {
        ...state,
        multi_view_state,
        version: 3,
      };
    },
  },
];
